import React from 'react';
import { Avatar } from 'antd';

/**
 * Avatar that shows colored initials when no src is available.
 * Deterministic color per name so each user has a stable hue.
 *
 * Usage: <InitialsAvatar src={url} name={'Ali Mohamed'} size={48} />
 */
const PALETTE = [
  '#0D7377', '#14A5AA', '#F4A623', '#7C3AED', '#3B82F6',
  '#EC4899', '#10B981', '#EF4444', '#0EA5E9', '#8B5CF6',
];

function colorFor(seed) {
  let h = 0;
  for (let i = 0; i < (seed || '').length; i++) h = (h * 31 + seed.charCodeAt(i)) & 0xffffffff;
  return PALETTE[Math.abs(h) % PALETTE.length];
}

function initials(name) {
  if (!name) return '?';
  // Arabic + Latin support — take first letter of first 2 words
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0] || '').join('').toUpperCase() || '?';
}

export default function InitialsAvatar({ src, name, username, size = 40, style, className }) {
  const display = name || username || '';
  if (src) {
    return <Avatar src={src} size={size} style={style} className={className} />;
  }
  return (
    <Avatar
      size={size}
      className={className}
      style={{
        background: colorFor(display),
        color: '#fff',
        fontWeight: 700,
        fontSize: Math.max(12, Math.round(size * 0.40)),
        ...style,
      }}
    >
      {initials(display)}
    </Avatar>
  );
}
